import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import ReactDOM from 'react-dom';
import LoadingBar from 'react-top-loading-bar';
import { mutate } from 'swr';
import { AppRouteUi, PaginationSettings } from '../../configs';
import { AdminPageTemplate, Searchbar } from "../../features";
import { ApiSchemaVendorSipHeaderModel } from '../../models';
import { useFunctionalityVendorSipHeader } from '../../pages/hooks';
import { ModalAddSipHeader, ModalConfirmDelete } from '../modals';
import { AssetSvg } from '../../assets';

export function VendorSipHeadersTab() {
  const vendorId = AppRouteUi.Vendors.Profile.useParam();
  const [loaderProgress, setLoaderProgress] = useState(0);
  const [showDeleteModal, setDeleteShowModal] = useState(false);
  const [show, setShow] = React.useState(false);
  const [pageIndex, setPageIndex] = useState(PaginationSettings.initialPageIndex);
  const [pageSize, setPageSize] = useState(PaginationSettings.initialPageSize);
  const [searchText, setSearchText] = useState<string>("");
  const [headerIdToDelete, setHeaderIdToDelete] = useState<string>("");
  const [vendorName, setVendorName] = useState<string | null>(null);
  const [hasPagingData, setHasPagingData] = useState<boolean>(false);

  const [dataToEdit, setDataToEdit] = useState<ApiSchemaVendorSipHeaderModel | undefined>(
    undefined
  );

  const { onDeleteSipHeader } = useFunctionalityVendorSipHeader({
    setDeleteModalShow: setDeleteShowModal,
  });

  const {
    vendorSipHeaderList,
    vendorSipHeaderListCount,
    getAllSipHeadersUrl,
  } = useFunctionalityVendorSipHeader({
    shouldVendorSipHeaderGetAllInvoke: true,
    pageSize,
    pageNo: pageIndex,
    searchText: searchText?.trimStart(),
    // setLoaderProgress
    setEditModalShow: setShow,
  });

  useEffect(() => {
    if (vendorSipHeaderList?.length > 0) {
      setHasPagingData(true);
    } else {
      setHasPagingData(false);
    }
  }, [vendorSipHeaderList]);

  const handleSearch = (e: any) => {
    ReactDOM.unstable_batchedUpdates(() => {
      setSearchText(e.target.value);
      setPageIndex(1);
    });
  };
  const onChangePageIndex = (index: number) => {
    setPageIndex(index);
  };
  const onChangePageSize = (size: number) => {
    setPageSize(size);
  };

  const vendorSipHeadersTableColumns = [
    {
      name: "Header Name",
      selector: (row: ApiSchemaVendorSipHeaderModel) => row.headerName,
    },
    {
      name: "Header Value",
      selector: (row: ApiSchemaVendorSipHeaderModel) => row.headerValue,
    },
    {
      name: "Value Type",
      selector: (row: ApiSchemaVendorSipHeaderModel) =>
        row.valueType === 1 ? "Literal" : row.valueType === 0 ? "Dynamic" : "-",
    },
    {
      name: "Actions",
      allowOverflow: true,
      selector: (row: ApiSchemaVendorSipHeaderModel) => {
        return (
          <>
            <div
              className="btn svg-color"
              style={{ paddingLeft: "0px", paddingRight: "5px" }}
              title="Edit"
              onClick={() => {
                setDataToEdit(row); 
                setShow(true);
              }}
            >
              <span>
                <AssetSvg.Edit />
              </span>
            </div>
            <button
              className="btn btn-link svg-color py-0 "
              onClick={() => {
                setDeleteShowModal(true);
                setHeaderIdToDelete(row.id);
                setVendorName(row.headerValue);
              }}
            >
              <span>
                <AssetSvg.Delete />
              </span>
            </button>
          </>
        );
      },
    },
  ];

  const deleteHandler = () => {
    if (headerIdToDelete) {
      onDeleteSipHeader(headerIdToDelete)
        .then(() => {
          setDeleteShowModal(false);
          mutate(getAllSipHeadersUrl);
        })
        .catch((e) => console.error(e));
    }
  };

  return (
    <>
      <LoadingBar
        progress={loaderProgress}
        onLoaderFinished={() => setLoaderProgress(0)}
      />

      <div className="col-12 my-3 px-3">
        <button
          className="btn btn-primary text-uppercase"
          onClick={() => {
            setDataToEdit(undefined); 
            setShow(true);
          }}
        >
          <i className="s7 s7-plus"></i> Add Header
        </button>
      </div>

      <div className="px-3 pb-3">
        <AdminPageTemplate
          pagingKey={`VendorSipHeadersTab:${vendorId}`}
          loaderProgress={loaderProgress}
          tableHeaders={vendorSipHeadersTableColumns}
          tableData={vendorSipHeaderList || []}
          searchText={searchText}
          handleSearch={handleSearch}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          pageSize={pageSize}
          count={vendorSipHeaderListCount}
          onChangePageIndex={onChangePageIndex}
          onChangePageSize={onChangePageSize}
          hasPagingData={hasPagingData}
          setHasPagingData={setHasPagingData}
        />
      </div>

      {show && (
        <ModalAddSipHeader
          show={show}
          handleShow={setShow}
          vendorSipHeaderUrl={getAllSipHeadersUrl}
          dataToEdit={dataToEdit}
          setDataToEdit={setDataToEdit}
        />
      )}

      {showDeleteModal && (
        <ModalConfirmDelete
          show={showDeleteModal}
          handleShow={setDeleteShowModal}
          deleteHandler={deleteHandler}
          itemName={vendorName}
        />
      )}
    </>
  );
}
